import React, {memo} from "react"
import style from "styles/tokenEconomy.module.css"
import useLocale from '../../../../hooks/useLocale'

const TokenEconomy = () => {
	const {tokenEconomy} = useLocale()

	return (
		<div className={style.token}>
			<div className={style.container}>
				<div
					data-aos-once="true"
					data-aos="fade-right"
					data-aos-offset="200"
					data-aos-easing="ease-in-sine"
					className={style.content}
				>
					<div className={style.mainTitle}>{tokenEconomy.firstTitle}</div>

					<p className={style.title}>{tokenEconomy.gameEconomyFirstTitle}</p>
					<p className={style.text}>{tokenEconomy.gameEconomyFirstText}</p>

					<p className={style.title}>{tokenEconomy.gameEconomySecondTitle}</p>
					<p className={style.text}>{tokenEconomy.gameEconomySecondText}</p>

					<p className={style.title}>{tokenEconomy.gameEconomyThirdTitle}</p>
					<p className={style.text}>{tokenEconomy.gameEconomyThirdText}</p>

					<div className={style.mainTitle}>{tokenEconomy.secondTitle}</div>

					<p className={style.title}>{tokenEconomy.ecosystemFistTitle}</p>
					<p className={style.text}>{tokenEconomy.ecosystemFistText}</p>

					<p className={style.title}>{tokenEconomy.ecosystemSecondTitle}</p>
					<p className={style.text}>{tokenEconomy.ecosystemSecondText}</p>

					<p className={style.title}>{tokenEconomy.ecosystemThirdTitle}</p>
					<p className={style.text}>{tokenEconomy.ecosystemThirdText}</p>

					<p className={style.title}>{tokenEconomy.ecosystemFourthTitle}</p>
					<p className={style.text}>{tokenEconomy.ecosystemFourthText}</p>
				</div>
			</div>
		</div>
	)
}

export default memo(TokenEconomy)
